<template>
    <section class="page-auth-login">
        <header>
            <DIcon
                name="key-outline"
                :size="64"
            />
            <h1>{{ __('messages.login.title') }}</h1>
            <div class="header-actions">
                <DThemeToggle />
                <DButton
                    id="change-language"
                    v-c-tooltip="__('messages.header.language_button.title')"
                    icon="web"
                    @click="toggleLanguage"
                />
            </div>
        </header>

        <DCard
            :class="{'active' : authenticationMethods.local}"
        >
            <div class="login-method">
                <DIcon
                    name="form-textbox-password"
                    :size="32"
                />
                <div v-if="authenticationMethods.local === false">
                    <h1>{{ __('messages.login.local_login.title') }}</h1>
                    <p>{{ __('messages.login.local_login.body_disabled') }}</p>
                </div>
                <div v-if="authenticationMethods.local === true">
                    <h1>{{ __('messages.login.local_login.title') }}</h1>
                    <form @submit.prevent="handleLocalLoginClick">
                        <DFormRow
                            :label="__('messages.login.local_login.form.email')"
                            :is-vertical="true"
                        >
                            <DInput
                                id="email"
                                v-model="loginForm.email"
                                type="email"
                            />
                        </DFormRow>
                        <DFormRow
                            :label="__('messages.login.local_login.form.password')"
                            :is-vertical="true"
                        >
                            <DInput
                                id="password"
                                v-model="loginForm.password"
                                type="password"
                            />
                        </DFormRow>
                        <DButton
                            id="login"
                            name="login"
                            color="primary"
                            :label="__('messages.login.local_login.form.login')"
                            :disabled="isInLoadingState"
                            @click="handleLocalLoginClick"
                        />
                    </form>
                </div>
            </div>
        </DCard>
        <DCard
            :class="{'active' : authenticationMethods.sso}"
        >
            <div class="login-method">
                <DIcon
                    name="domain"
                    :size="32"
                />
                <div v-if="authenticationMethods.sso === false">
                    <h1>{{ __('messages.login.sso_login.title') }}</h1>
                    <p>{{ __('messages.login.sso_login.body_disabled') }}</p>
                </div>
                <div v-if="authenticationMethods.sso === true">
                    <h1>{{ __('messages.login.sso_login.title') }}</h1>
                    <DButton
                        id="login-via-odid"
                        icon="open-in-new"
                        :label="__('messages.login.sso_login.login_button')"
                        color="primary"
                        :disabled="isInLoadingState"
                        @click="handleSSOLoginClick"
                    />
                </div>
            </div>
        </DCard>
        <DToaster
            v-if="error"
            placement="top-end"
            visible
        >
            <DToast
                :key="'flash'"
                color="danger"
                :visible="true"
                :header-text="__('messages.error')"
                :body-text="error"
            />
        </DToaster>
    </section>
</template>

<script>
import AuthBase from '~@/Pages/Login/AuthBase'
import DThemeToggle from '~@/Components/App/Header/DThemeToggle.vue'

export default {
    name: 'LoginIndex',
    components: { DThemeToggle },
    layout: AuthBase,
    props: {
        uuid: {
            type: String,
            default: ''
        },
        loginLocale: {
            type: String,
            default: ''
        },
        authenticationMethods: {
            type: Object,
            default: () => ({
                sso: true,
                local: true
            })
        }
    },
    data () {
        return {
            loginForm: this.$inertia.form({
                email: '',
                password: ''
            }),
            error: null
        }
    },
    methods: {
        handleLocalLoginClick () {
            this.error = null
            this.loginForm.post(this.$route('login.local'), {
                onError: (error) => {
                    this.error = Object.values(error).join(', ')
                }
            })
        },
        handleSSOLoginClick () {
            window.location = this.$route('login.saml', { uuid: this.uuid })
        },
        toggleLanguage () {
            this.$inertia.post(this.$route('login.toggle_language', { login_locale: this.login_locale }))
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    text-align: center;

    & .mdi {
        margin-bottom: 10px;
        color: #f5c844;
    }
    & h1 {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 25px;
    }
    & .header-actions {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-bottom: 25px;
    }
}
.d-card {
    margin-bottom: 25px;

    & .login-method {
        padding: 25px;
        display: grid;
        grid-template-columns: 32px auto;
        grid-gap: 25px;

        & > .mdi {
            justify-self: center;
            align-self: center;
        }

        & > div {
            align-self: center;

            & h1 {
                font-size: 20px;
                margin: 0 0 10px;
            }

            & p {
                color: rgba(0, 0, 0, 0.6);
                margin: 0;
            }

            & form {
                display: grid;
                grid-template-columns: 1fr 1fr auto;
                align-items: flex-end;
                grid-gap: 15px;

                & > div {
                    margin: 0;

                    & input {
                        padding: 0;
                    }
                }
            }
        }
    }

    &:not(.active) {
        opacity: 0.5;
    }
}
</style>
